import { Col, Form, Input, message, Row, Typography } from "antd";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { translate } from "../../locale";
import DashServices from "../../services/DashServices";
import UserServices from "../../services/UserServices";
import PrimaryButton from "../Buttons/PrimaryButton";
import Label from "./Label";

const { Title } = Typography;

const RangeForm = ({ initialValues, title, onlyMax }) => {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState(initialValues);
  const [checkboxValues, setCheckboxValues] = useState({
    patient: initialValues.patient,
    type: initialValues.type,
    max_value_alert: false,
    max_value: false,
    min_value: false,
    min_value_alert: false,
  });
  const [error, setError] = useState("");

  useEffect(() => {
    getRanges();
  }, []);

  const getRanges = async () => {
    try {
      setLoading(true);
      const r = await UserServices.getPatientRange(initialValues.patient);
      if (r.status === 200) {
        const ranges = r.data.ranges.findLast(
          (i) => i.type === initialValues.type
        );
        setValues((v) => ({
          ...v,
          ...ranges,
        }));

        if (ranges?.max_value_alert_check === undefined) {
          console.log(
            `No está configurado el rango para ${initialValues.type}`
          );
        } else {
          setCheckboxValues((v) => ({
            ...v,
            max_value_alert: ranges.max_value_alert_check,
            max_value: ranges.max_value_check,
            min_value: ranges.min_value_check,
            min_value_alert: ranges.min_value_alert_check,
          }));
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleSaveRange = async () => {
    setLoading(true);
    try {
      const res = await DashServices.updateRange(values);
      const resCheck = await DashServices.updateCheckboxRange(checkboxValues);
      if (res.data.message === "ok" && resCheck.data.message === "ok") {
        message.success("Los rangos han sido actualizados exitosamente.");
      } else {
        setError(res.data.message);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setError(error);
      setLoading(false);
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckboxValues((v) => ({ ...v, [name]: checked }));
  };

  return (
    <Row className="border border-solid border-custom_gray">
      <Col span={24} className="py-2 px-4 lg:px-6 bg-custom_lightgray">
        <Title level={4} className="!text-lg lg:!text-2xl">
          {title}
        </Title>
      </Col>

      <Col className="p-4 lg:p-6" span={24}>
        <Form onFinish={handleSaveRange}>
          <Row gutter={32}>
            <Col xs={{ span: 12 }}>
              {!onlyMax && (
                <Row justify="start" className="mb-2">
                  <Col className="flex justify-center items-center py-2 px-8 w-32 md:w-64">
                    {translate("MÁX")}
                  </Col>
                </Row>
              )}
              <Label
                checkbox={{
                  name: "max_value_alert",
                  onChange: handleCheckboxChange,
                  checked: checkboxValues.max_value_alert,
                  value: true,
                }}
                type="exclamation"
              />
              <Label
                checkbox={{
                  name: "max_value",
                  onChange: handleCheckboxChange,
                  checked: checkboxValues.max_value,
                  value: true,
                }}
                type="warning"
              />
              {(!onlyMax || values.type === "hs_alimentacion") && (
                <Label type="check" />
              )}
              {!onlyMax && (
                <>
                  <Label
                    checkbox={{
                      name: "min_value",
                      onChange: handleCheckboxChange,
                      checked: checkboxValues.min_value,
                      value: true,
                    }}
                    type="warning"
                  />
                  <Label
                    checkbox={{
                      name: "min_value_alert",
                      onChange: handleCheckboxChange,
                      checked: checkboxValues.min_value_alert,
                      value: true,
                    }}
                    type="exclamation"
                  />
                  <Row justify="start">
                    <Col className="flex justify-center items-center py-2 px-8 w-32 lg:w-64">
                      {translate("MIN")}
                    </Col>
                  </Row>
                </>
              )}
            </Col>
            <Col
              xs={{ span: 12 }}
              className={`flex flex-col justify-center ${
                onlyMax ? "-mt-2 pt-2 md:pt-0" : ""
              }`}
            >
              <Row className="mb-2" style={{ height: 68 }}>
                <Col className="flex justify-start items-center">
                  <Input
                    type="number"
                    name="max_value_alert"
                    value={values.max_value_alert}
                    onChange={handleChange}
                  />
                </Col>
              </Row>
              <Row className="mb-2" style={{ height: 68 }}>
                <Col className="flex justify-start items-center">
                  <Input
                    type="number"
                    name="max_value"
                    value={values.max_value}
                    onChange={handleChange}
                  />
                </Col>
              </Row>
              <Row className="mb-2" style={{ height: 68 }}>
                <Col></Col>
              </Row>
              {!onlyMax && (
                <>
                  <Row className="mb-2" style={{ height: 68 }}>
                    <Col className="flex justify-start items-center">
                      <Input
                        type="number"
                        name="min_value"
                        value={values.min_value}
                        onChange={handleChange}
                      />
                    </Col>
                  </Row>
                  <Row style={{ height: 68 }}>
                    <Col className="flex justify-start items-center">
                      <Input
                        type="number"
                        name="min_value_alert"
                        value={values.min_value_alert}
                        onChange={handleChange}
                      />
                    </Col>
                  </Row>
                </>
              )}
            </Col>
            {error && (
              <Col span="24" className="text-center text-custom_red mt-4">
                {error}
              </Col>
            )}
            <Col span="24" className="text-center mt-4">
              <PrimaryButton htmlType="submit" loading={loading}>
                {translate("Guardar")}
              </PrimaryButton>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

RangeForm.propTypes = {
  initialValues: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  onlyMax: PropTypes.bool.isRequired,
};

export default RangeForm;
